module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramdasauce/~/ramda/src/internal/_isString.js
 ** module id = 96
 ** module chunks = 0
 **/